const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

// Scroll in animation logic
function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      if (elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (elementTarget.hasAttribute('data-cascade'))
          elementTarget.setAttribute('style', `--animation-order: ${index};`);
      }
      observer.unobserve(elementTarget);
    } else {
      element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const animationTriggerElements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => {
      element.classList.add('scroll-trigger--design-mode');
    });
    return;
  }

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '0px 0px -50px 0px',
  });
  animationTriggerElements.forEach((element) => observer.observe(element));
}

// Zoom in animation logic
function initializeScrollZoomAnimationTrigger() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const animationTriggerElements = Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));

  if (animationTriggerElements.length === 0) return;

  const scaleAmount = 0.2 / 100;

  animationTriggerElements.forEach((element) => {
    let elementIsVisible = false;
    const observer = new IntersectionObserver((elements) => {
      elements.forEach((entry) => {
        elementIsVisible = entry.isIntersecting;
      });
    });
    observer.observe(element);

    element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));

    window.addEventListener(
      'scroll',
      throttle(() => {
        if (!elementIsVisible) return;

        element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));
      }),
      { passive: true }
    );
  });
}

function percentageSeen(element) {
  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;
  const elementPositionY = element.getBoundingClientRect().top + scrollY;
  const elementHeight = element.offsetHeight;

  if (elementPositionY > scrollY + viewportHeight) {
    // If we haven't reached the image yet
    return 0;
  } else if (elementPositionY + elementHeight < scrollY) {
    // If we've completely scrolled past the image
    return 100;
  }

  // When the image is in the viewport
  const distance = scrollY + viewportHeight - elementPositionY;
  let percentage = distance / ((viewportHeight + elementHeight) / 100);
  return Math.round(percentage);
}

window.addEventListener('DOMContentLoaded', () => {
  initializeScrollAnimationTrigger();
  initializeScrollZoomAnimationTrigger();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target, true));
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
}

function initializeItNapsMobileProductAdd(rootEl = document) {
  const panels = rootEl.querySelectorAll('[data-itnaps-mobile-add]');

  panels.forEach((panel) => {
    if (panel.dataset.mobileAddReady === 'true') return;
    panel.dataset.mobileAddReady = 'true';

    const productRoot = panel.closest('product-info') || document.querySelector('product-info.itnaps-fable-pdp') || document;
    const variantsScript = panel.querySelector('[data-mobile-variants]');
    const variantInput = panel.querySelector('[data-mobile-variant-id]');
    const quantityInput = panel.querySelector('[data-mobile-quantity]');
    const submitButton = panel.querySelector('.itnaps-mobile-add__button');
    const submitText = panel.querySelector('[data-mobile-submit-text]');
    const summary = panel.querySelector('[data-mobile-option-summary]');
    const changeOptions = panel.querySelector('[data-mobile-change-options]');
    const defaultSummary = panel.dataset.defaultSummary || '';
    const mainBuyButtons = productRoot.querySelector('.itnaps-fable-pdp__info .product-form__buttons');

    if (!variantsScript || !variantInput || !submitButton || !submitText || !summary) return;

    let variants = [];
    try {
      variants = JSON.parse(variantsScript.textContent || '[]');
    } catch (error) {
      variants = [];
    }

    const getVariantSelects = () => productRoot.querySelector('variant-selects');

    const selectedOptions = () => {
      const variantSelects = getVariantSelects();
      if (!variantSelects) return [];

      return Array.from(variantSelects.querySelectorAll('fieldset, .product-form__input--dropdown'))
        .map((group) => {
          const checked = group.querySelector('input:checked');
          if (checked) return checked.value;

          const select = group.querySelector('select');
          if (select) return select.value;

          return '';
        })
        .filter(Boolean);
    };

    const findSelectedVariant = () => {
      const options = selectedOptions();
      if (!options.length) return variants[0];

      return variants.find((variant) => variant.options.every((option, index) => option === options[index]));
    };

    const setPanelVariant = (variant) => {
      const optionText = variant?.options?.filter((option) => option && option !== 'Default Title').join(' / ');
      summary.textContent = optionText || defaultSummary;

      if (!variant) {
        variantInput.value = '';
        variantInput.disabled = true;
        submitButton.disabled = true;
        submitText.textContent = 'Unavailable';
        submitButton.title = 'Unavailable';
        return;
      }

      variantInput.value = variant.id;
      variantInput.disabled = !variant.available;
      submitButton.disabled = !variant.available;
      submitText.textContent = variant.available ? 'Add To Cart' : 'Sold out';
      submitButton.title = variant.available ? 'Add To Cart' : 'Sold out';
    };

    const syncQuantity = () => {
      if (!quantityInput) return;

      const mainQuantity = productRoot.querySelector(`#Quantity-${productRoot.dataset.section}`);
      quantityInput.value = mainQuantity?.value || '1';
    };

    const updatePanel = (variant = findSelectedVariant()) => {
      setPanelVariant(variant);
      syncQuantity();
    };

    const setVisible = (isVisible) => {
      panel.classList.toggle('is-visible', isVisible);
      panel.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
      if ('inert' in panel) panel.inert = !isVisible;
    };

    const isSideDrawerOpen = () =>
      Boolean(
        document.querySelector(
          '.itnaps-fable-header__drawer[open], cart-drawer.active, .drawer.active, menu-drawer details.menu-opening'
        )
      );

    const updateVisibility = () => {
      if (!window.matchMedia('(max-width: 989px)').matches || isSideDrawerOpen()) {
        setVisible(false);
        return;
      }

      if (!mainBuyButtons) {
        setVisible(window.scrollY > 480);
        return;
      }

      const rect = mainBuyButtons.getBoundingClientRect();
      setVisible(rect.bottom <= 0);
    };

    const requestVisibilityUpdate = () => window.requestAnimationFrame(updateVisibility);

    productRoot.addEventListener('change', (event) => {
      if (!event.target.closest('variant-selects') && event.target.id !== `Quantity-${productRoot.dataset.section}`) return;
      window.requestAnimationFrame(() => updatePanel());
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        if (event.data?.sectionId !== productRoot.dataset.section) return;
        updatePanel(event.data.variant);
      });
    }

    changeOptions?.addEventListener('click', (event) => {
      event.preventDefault();

      const target =
        getVariantSelects() ||
        productRoot.querySelector('.itnaps-fable-pdp__quantity') ||
        productRoot.querySelector('.itnaps-fable-pdp__info');

      target?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      const focusTarget = target?.querySelector('input, select, button, a');
      if (focusTarget) window.setTimeout(() => focusTarget.focus({ preventScroll: true }), 360);
    });

    if ('IntersectionObserver' in window && mainBuyButtons) {
      const observer = new IntersectionObserver(updateVisibility, {
        root: null,
        threshold: [0, 0.01, 1],
      });
      observer.observe(mainBuyButtons);
    }

    window.addEventListener('scroll', updateVisibility, { passive: true });
    window.addEventListener('resize', updateVisibility);
    document.addEventListener('toggle', requestVisibilityUpdate, true);
    document.addEventListener('click', requestVisibilityUpdate, true);

    if ('MutationObserver' in window) {
      const drawerObserver = new MutationObserver(requestVisibilityUpdate);
      document
        .querySelectorAll('.itnaps-fable-header__drawer, cart-drawer, .drawer, menu-drawer details')
        .forEach((drawerTarget) => {
          drawerObserver.observe(drawerTarget, { attributes: true, attributeFilter: ['class', 'open'] });
        });
    }

    updatePanel();
    updateVisibility();
  });
}

function fetchItNapsMobileProductAdd() {
  const productRoot = document.querySelector('product-info.itnaps-fable-pdp');
  if (!productRoot || productRoot.querySelector('[data-itnaps-mobile-add]')) return;
  if (productRoot.dataset.mobileAddFetchStarted === 'true' || !productRoot.dataset.section || !window.fetch) return;

  productRoot.dataset.mobileAddFetchStarted = 'true';

  const sectionUrl = new URL(window.location.href);
  sectionUrl.search = '';
  sectionUrl.searchParams.set('section_id', productRoot.dataset.section);

  fetch(sectionUrl.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
    .then((response) => {
      if (!response.ok) throw new Error('Section request failed');
      return response.text();
    })
    .then((html) => {
      if (productRoot.querySelector('[data-itnaps-mobile-add]')) return;

      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const panel = parsed.querySelector('[data-itnaps-mobile-add]');
      if (!panel) return;

      const target = productRoot.querySelector('product-component') || productRoot;
      target.appendChild(document.importNode(panel, true));
      initializeItNapsMobileProductAdd(productRoot);
    })
    .catch(() => {
      productRoot.dataset.mobileAddFetchStarted = 'false';
    });
}

window.addEventListener('DOMContentLoaded', () => {
  initializeItNapsMobileProductAdd();
  fetchItNapsMobileProductAdd();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeItNapsMobileProductAdd(event.target));
}
